/** Tenant energy bills /metering/bill/energy-bill-tenant (energyBill.vue) */
export default {
  energyBillPage: {
    phDateStart: 'Start date',
    phDateEnd: 'End date',
    phTenant: 'Tenant name / ID',
    phTenantType: 'Tenant type',
    tenantType0: 'Tenant',
    tenantType1: 'Common area',
    tenantType2: 'Other',
    tenantType3: 'Solar',
    phBillType: 'Charge type',
    phSettleWay: 'Bill type',
    phPayType: 'Payment mode',
    billTypeElectric: 'Electricity',
    billTypeWater: 'Water',
    billTypeService: 'Service fee',
    settleWay0: 'Standard settlement',
    settleWay1: 'Manual debit',
    settleWay2: 'System adjustment',
    settleWay3: 'Floating tariff',
    settleWay4: 'Allocation settlement',
    settleWay5: 'Equipment debit',
    settleWay10: 'Tenant top-up',
    optPayPrepaid: 'Prepaid',
    optPayPostpaid: 'Postpaid',
    btnSearch: 'Search',
    btnReset: 'Reset',
    btnExport: 'Export',
    exportCurrentPage: 'Export current page',
    exportSelected: 'Export selected',
    exportAll: 'Export all',
    warnNoSelectedExport: 'Please select rows to export',
    btnExpand: 'Expand',
    btnCollapse: 'Collapse',
    tooltipMeterElec: 'Metered electricity:',
    tooltipOtherElec: 'Other electricity:',
    tooltipMeterWater: 'Metered water:',
    tooltipOtherWater: 'Other water:',
    tooltipTotal: 'Total:',
    statElectricity: 'Electricity',
    statWater: 'Water',
    statServiceFee: 'Service fee',
    statGrandTotal: 'Total',
    sectionTitle: 'Tenant bills',
    sortDefault: 'Default sort',
    selectedLine: '<span class="count">{count}</span> row(s) selected',
    payPaid: 'Paid',
    payUnpaid: 'Unpaid',
    colAction: 'Actions',
    btnDetail: 'Details',
    shortcut7d: 'Last 7 days',
    shortcut15d: 'Last 15 days',
    shortcut30d: 'Last 30 days',
    shortcutThisMonth: 'This month',
    shortcutLastMonth: 'Last month',
    colRid: 'Bill no.',
    colOccurDate: 'Bill date',
    colCreateTime: 'Created',
    colTenantInfo: 'Tenant',
    colPayType: 'Payment mode',
    colBillType: 'Charge type',
    colSettleWay: 'Bill type',
    colBalance: 'Amount',
    colPayStatus: 'Payment',
    colDiscountAmt: 'Credit paid (¥)',
    colRealAmt: 'Cash paid (¥)',
    colStatus: 'Invoice status',
    invoice0: 'Not invoiced',
    invoice1: 'Pending review',
    invoice2: 'Invoiced',
    invoice3: 'Rejected',
    msgFetchListFail: 'Failed to load data',
    msgFetchBillFail: 'Failed to load bills',
    msgExportListFail: 'Failed to load export data',
    msgNoDataExport: 'No data to export',
    exportLoading: 'Loading all bills for export…',
    msgNoRowsExport: 'No rows to export',
    msgExportFail: 'Export failed. Please try again.',
    msgExportOk: 'Exported {count} row(s).',
    msgExportOkSelected: 'Exported {count} selected row(s).',
    successExported: 'Exported {count} row(s)',
    successExportedLimit: '{total} row(s) in total, first {count} row(s) exported',
    exportSheetName: 'Energy bills',
    filePrefix: 'TenantEnergyBill',
    billTypeUseWater: 'Water',
    billTypeUseElectric: 'Electricity',
    billTypeUseService: 'Service fee'
  }
}
